export const TOUR_HOME = 'tour-home'
export const ALL_TOURS = [TOUR_HOME]
